import React, {Component} from "react";
import DefaultModal from "../../invoice/DefaultModal";
import {request, requestWithoutHeader} from "../../../helper/APIUtils";
import {
    Button,
    Col,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledTooltip
} from "reactstrap";
import moment from "moment/moment";
import Datetime from 'react-datetime';
import {validateFinancialField} from "../../../common/validation";
import Select from "../../../local_node_modules/react-select";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {isValidFinancial, isValidReportDelivery} from "../../../common/componentValidation";
import Alert from "react-s-alert";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import DraggerUpload from "../../../components/DraggerUpload";

class FinancialSealModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false,
            shouldPayment: null,
            registerInfos: [],
            data: {
                kullaniciAd: "",
                kullaniciSoyad: "",
                kullaniciKimlikNo: "",
                vergiDairesi: "",
                kullaniciDogumYeri: "",
                mobilOperatorTipi: "3",
                bilgiKanali: "2",
                kullaniciIletisimEposta: "",
            },
            teslimEdilenAdSoyad: "",
            teslimEdilenTckn: "",
            teslimEdilenTelefon: "",
            basvuruNo: "",
            allCities: [],
            filteredDistricts: [],
            editMode: false,
            reportDeliveryModal: false,
            saveLoading: false,
            uploadFilesModal: false,
            selectedItem: {},
            uploadFileType: null,
            isImzaSirkuleri: false,
            loadingType: null
        }
        this.fetchCities = this.fetchCities.bind(this);
        this.fetchFinancialToken = this.fetchFinancialToken.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        this.fetchRegisterInfo = this.fetchRegisterInfo.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.groupByCityName = this.groupByCityName.bind(this);
        this.filterDistrictsByCity = this.filterDistrictsByCity.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.payment = this.payment.bind(this);
        this.getPaymentStatus = this.getPaymentStatus.bind(this);
        this.getOdemeDurumu = this.getOdemeDurumu.bind(this);
        this.getTeslimatDurumu = this.getTeslimatDurumu.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.copied = this.copied.bind(this);
        this.setDataByCustomer = this.setDataByCustomer.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.reportDelivery = this.reportDelivery.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.findCityCodeByName = this.findCityCodeByName.bind(this);
        this.openReportDeliveryModal = this.openReportDeliveryModal.bind(this);
        this.uploadFiles = this.uploadFiles.bind(this);
        this.setUploadFilesModal = this.setUploadFilesModal.bind(this);

    }

    async componentDidMount() {
        await this.fetchCities();
        this.fetchFinancialToken();
        this.fetchRegisterInfo();
    }

    async fetchCities(){
        let allCities = []
        return request({
            url: `/kolayPayment/getCities`,
            method: 'get'
        }).then(response => {
            if (response.data){
                 allCities = response.data;
                let cities = this.groupByCityName(allCities);
                this.setState({cities, allCities});
                return Promise.resolve(response.data);
            }
        }).catch(error => {
            showAxiosError(error);
            return Promise.resolve(allCities);
        });
    }


    fetchFinancialToken() {
        this.setState({loading: true});
        let customerId = this.props.customer.recordId;
        let params = {
            url: `/kolayPayment/getFinancialToken`,
            method: 'post',
            data: customerId
        };
        request(params)
            .then((response) => {
                let customer = response.data.customer;
                let shouldPayment = response.data.shouldPayment;
                this.setState({
                    shouldPayment,
                    customer,
                    loading: false
                }, () => this.setDataByCustomer(customer));
            }).catch(error => {
            this.setState({loading: false});
            showAxiosError(error);
        });
    }

    setDataByCustomer(customer) {
        this.setState({loading: true})
        let data = deepCopyObject(this.state.data);
        data["kullaniciAd"] = customer.givenName;
        data["kullaniciSoyad"] = customer.familyName;
        data["kullaniciKimlikNo"] = customer.vknTckn.length === 11 ? customer.vknTckn : customer.sorumluTckn;
        data["kullaniciIletisimEposta"] = customer.sorumluEPosta;
        data["kullaniciIl"] = this.findCityCodeByName(customer.city);
        if(data["kullaniciIl"]){
            this.filterDistrictsByCity(data["kullaniciIl"])
        }
        data["tuzel"] = customer.vknTckn.length === 10 ? 1 : 0;
        data["kullaniciVergiNo"] = customer.vknTckn.length === 10 ? customer.vknTckn : null;
        if (customer.sorumluCepTel !== null && customer.sorumluCepTel.startsWith("+90")) {
            let formattedNumber = customer.sorumluCepTel.slice(3);
            data["kullaniciCepTelefonu"] = formattedNumber;
        } else {
            data["kullaniciCepTelefonu"] = customer.sorumluCepTel;
        }

        this.setState({data, loading: false});
    }

    findCityCodeByName(cityName) {
        const city = this.state.cities && this.state.cities.find(city => city.cityName.toLowerCase() === cityName.toLowerCase());
        return city ? city.cityCode : null;
    }

    groupByCityName = (cities) => {
        const uniqueCities = {};
        cities.forEach(record => {
            if (!uniqueCities[record.cityName]) {
                uniqueCities[record.cityName] = {
                    cityName: record.cityName,
                    cityCode: record.cityCode
                };
            }
        });
        return Object.values(uniqueCities);
    }

    filterDistrictsByCity = (cityCode) => {
        const {allCities} = this.state;
        const filteredData = allCities
            .filter(record => record.cityCode == cityCode)
            .map(record => ({
                districtName: record.districtName,
                districtCode: record.districtCode
            }));
        this.setState({filteredDistricts: filteredData});
    }

    sendRequest(recordId) {
        let params = {
            url: `/kolayPayment/sendRequest`,
            method: "post",
            data: recordId
        };
        this.setState({loading: true});
        request(params)
            .then(response => {
                this.setState({loading: false, data: {
                        kullaniciAd: "",
                        kullaniciSoyad: "",
                        kullaniciKimlikNo: "",
                        vergiDairesi: "",
                        kullaniciDogumYeri: "",
                        mobilOperatorTipi: "3",
                        bilgiKanali: "2",
                        kullaniciIletisimEposta: "",
                    }},()=> {
                    this.fetchFinancialToken();
                    this.fetchRegisterInfo();
                });
                Alert.success("Kayıt işlemi başarıyla gönderildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });

            }).catch(error => {
            this.setState({loading: false});
            showAxiosError(error);
        });
    }

    checkStatus(barcode) {
        let params = {
            url: `/kolayPayment/checkAppStatus`,
            method: "post",
            data: barcode
        };
        this.setState({loading: true});
        request(params)
            .then(response => {
                let responseData  = response.data;
                const html = `<p style="font-size: 20px">Barkod No: <strong style="font-weight: bold;">${barcode}</strong> ait başvuru <br/> </p> <p style="font-size: 15px"> Ödeme Durumu: <strong style="font-weight: bold;">${responseData.odemeDurumu === "ODENDI" ? "ÖDENDİ" : "ÖDENMEDİ"}</strong>  ve Teslimat Durumu: <strong style="font-weight: bold;">${responseData.teslimatDurumu === "TESLIM_EDILDI" ? "TESLİM EDİLDİ" : "TESLİM EDİLMEDİ"}</strong></p>`;
                Swal({
                    title: 'Sorgulama işlemi başarıyla gerçekleştirildi.',
                    html: html,
                    allowOutsideClick: false,
                    confirmButtonText: 'Tamam',
                }).then((result) => {
                    if (result.value) {
                        this.setState({loading: false}, () => this.fetchRegisterInfo());
                        Swal.close();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        this.setState({loading: false}, () => this.fetchRegisterInfo());
                        Swal.close();
                    }
                });
            }).catch(error => {
            this.setState({loading: false});
            showAxiosError(error);
        });
    }

    downloadDocument(recordId) {
        let params = {
            url: `/kolayPayment/downloadDocument`,
            responseType: 'arraybuffer',
            method: "post",
            data: recordId
        };

        request(params).then((response) => {
            let blob = new Blob([response.data], {type: response.headers["content-type"]});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "urun_teslim_agt.pdf";
            document.body.appendChild(link);
            link.click();
        }).catch(error => {
            showAxiosError(error);
        })
    }

    setUploadFilesModal(selectedItem){
        let uploadFileType = null;
        let isImzaSirkuleri = false;
        if(selectedItem.kullaniciKimlikNo === selectedItem.teslimEdilenTckn){
            uploadFileType = "teslimTutanagi";
        }else{
            uploadFileType = "vekalet";
        }

        if(selectedItem.tuzel){
            isImzaSirkuleri = true;
        }
        this.setState({uploadFileType, uploadFilesModal: true, selectedItem, isImzaSirkuleri});
    }

    uploadFiles(files, type) {
        this.setState({ loadingType: type });
        let { responseType, responseMsg } = this.state;
        const formData = new FormData();

        if (files.length > 1) {
            responseType = "error";
            responseMsg = "Lütfen yalnızca bir dosya yükleyin.";
            this.setState({ responseType, responseMsg, loadingType: null });
            return;
        } else if (files.length === 1) {
            formData.append("file", files[0]);
            formData.append("recordId", this.state.selectedItem.recordId);
            formData.append("type", type);

            let params = {
                url: `/kolayPayment/uploadFiles`,
                method: "post",
                data: formData,
            };

            return request(params)
                .then(response => {
                    responseType = "success";
                    responseMsg = "Dosya yükleme işlemi başarılı.";
                    this.setState(prevState => ({
                        responseType,
                        responseMsg,
                        selectedItem: response.data.tokenRequest,
                        loadingType: null
                    }));
                    return response.data.message;
                })
                .catch(error => {
                    let errorMsg ;
                    if (error.response) {
                        errorMsg = error.response.data || errorMsg;
                    }
                    errorMsg = errorMsg.replace(/\[[^\]]*\]/g, "").trim();

                    this.setState(prevState => ({
                        responseType: "error",
                        responseMsg: errorMsg,
                        loadingType: null
                    }));
                    throw errorMsg;
                });
        }
    }

    openReportDeliveryModal(registerInfo){
        let customer = this.state.customer;
        let teslimEdilenAdSoyad = "";
        let teslimEdilenTckn = "";
        let teslimEdilenTelefon = "";
        if (customer.vknTckn.length === 10) {
            teslimEdilenAdSoyad =
                (customer.sorumluAd && customer.sorumluSoyad )
                    ?  customer.sorumluAd + " " + customer.sorumluSoyad
                    : "";
            teslimEdilenTckn = customer.sorumluTckn ? customer.sorumluTckn : "";
        } else {
            teslimEdilenAdSoyad =
                (customer.givenName && customer.familyName) ? customer.givenName + " " + customer.familyName
                    : "";
            teslimEdilenTckn = customer.vknTckn;
        }

        teslimEdilenTelefon = customer.sorumluCepTel;
        if(customer && customer.sorumluCepTel && customer.sorumluCepTel.startsWith("+90")){
            teslimEdilenTelefon = teslimEdilenTelefon.slice(3);
        }

        this.setState({
            reportDeliveryModal: true,
            basvuruNo: registerInfo.barcode,
            teslimEdilenAdSoyad,
            teslimEdilenTckn,
            teslimEdilenTelefon
        })
    }

    reportDelivery() {
        let {teslimEdilenAdSoyad, teslimEdilenTckn, basvuruNo,teslimEdilenTelefon } = this.state;
        let dataDelivery = {teslimEdilenAdSoyad, teslimEdilenTckn, teslimEdilenTelefon};
        let result = isValidReportDelivery(dataDelivery);
        let error = result.error;
        let valid = result.valid;
        if(valid) {
            dataDelivery.barcode = basvuruNo;
            let params = {
                url: `/kolayPayment/reportDelivery`,
                method: "post",
                data: dataDelivery
            };
            this.setState({loading: true, reportDeliveryModal: false});
            request(params)
                .then(response => {
                    Alert.success("Teslim Bildirme işlemi başarıyla gerçekleştirildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    this.setState({
                        loading: false,
                        reportDeliveryModal: false,
                        teslimEdilenTckn: null,
                        teslimEdilenAdSoyad: null,
                        teslimEdilenTelefon: null,
                        basvuruNo: null
                    });
                }).catch(error => {
                this.setState({
                    loading: false,
                    reportDeliveryModal: false,
                    teslimEdilenTckn: null,
                    teslimEdilenAdSoyad: null,
                    teslimEdilenTelefon: null,
                    basvuruNo: null
                });
                showAxiosError(error);
            });
        } else {
            Alert.error("Hatalı veya boş alanlar var.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000
            });
            this.setState({error, loading: false });
        }
    }

    handleEdit(info) {
        let yeniDogumTarihi = moment(info.kullaniciDogumTarihi, 'DD/MM/YYYY').format('DD-MM-YYYY');
        info["kullaniciDogumTarihi"] = yeniDogumTarihi;
        this.setState({data: info, editMode: true}, () => this.filterDistrictsByCity(info.kullaniciIl));
    }

    saveRequest(e) {
        e.preventDefault();
        this.setState({loading: true, saveLoading: true});
        let data = deepCopyObject(this.state.data);
        let shouldPayment = this.state.shouldPayment;
        let result = isValidFinancial(data);
        let error = result.error;
        let valid = result.valid;
        let kullaniciDogumTarihi = moment(data.kullaniciDogumTarihi, 'DD-MM-YYYY').format('DD/MM/YYYY');
        let customerId = this.props.customer.recordId;
        let merchantOkUrl = window.location.origin;
        data = {
            ...this.state.data, kullaniciDogumTarihi, customerId
        };
        if (valid) {
            this.setState({loading: false, saveLoading: false});
            let params = {
                url: `/kolayPayment/save`,
                method: "post",
                data: {
                    tokenRequest: data,
                    merchantOkUrl,
                    shouldPayment
                }
            };
            request(params)
                .then(response => {
                    this.setState({loading: false, editMode: false, saveLoading: false}, () => this.fetchRegisterInfo());
                    Alert.success("Kayıt işlemi başarıyla gerçekleştirildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                }).catch(error => {
                this.setState({loading: false, saveLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error("Hatalı veya boş alanlar var.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000
            });
            this.setState({error, loading: false , saveLoading: false});
        }
    }

    validateField(e, label) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let error = this.state.error;
        let result = validateFinancialField(rule, boundary, e.target.value, label);
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    onValueChange(e, name) {
        let data = deepCopyObject(this.state.data);
        data[name] = e.target.value;
        if (name === "kullaniciIl") {
            data["kullaniciIlce"] = null;
            this.filterDistrictsByCity(e.target.value)
        }
        this.setState({data});
    }

    async fetchRegisterInfo() {
        let self = this;
        let customerId = this.props.customer.recordId;
        let params = {
            url: `/kolayPayment/fetchRegisterInfo/${customerId}`,
            method: "get",
        };
        self.setState({loading: true});
        await request(params).then((response) => {
            self.setState({
                registerInfos: response.data,
                loading: false
            });
        }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });

    }

    payment(merchantOid) {
        window.location.href = this.props.paytrDomain + "/external/" + merchantOid;
    }

    getPaymentStatus(status) {
        let htmlResult = "";
        if (status === 0) {
            htmlResult = "ÖDEME BEKLENİYOR"
        } else if (status === 1) {
            htmlResult = "ÖDEME BAŞARISIZ"
        } else if (status === 2) {
            htmlResult = "ÖDEME BAŞARILI"
        } else {
            htmlResult = "";
        }
        return (
            <span>
        <p style={{margin: 0}}
           className={status === 2 ? "text-success" : (status === 1 ? "text-danger" : (status === 0 ? "text-info" : "text-secondary"))}>
				{htmlResult}
        </p>
        </span>
        );
    }

    getOdemeDurumu(status) {
        let htmlResult = "";
        if (status === "ODENMEDI") {
            htmlResult = "ÖDENMEDİ"
        } else if (status === "ODENDI") {
            htmlResult = "ÖDENDİ"
        } else {
            htmlResult = "";
        }
        return (
            <span>
        <p style={{margin: 0}}
           className={status === "ODENDI" ? "text-success" : (status === "ODENMEDI" ? "text-danger" : "text-secondary")}>
				{htmlResult}
        </p>
        </span>
        );
    }

    getTeslimatDurumu(status) {
        let htmlResult = "";
        if (status === "TESLIM_EDILMEDI") {
            htmlResult = "TESLİM EDİLMEDİ"
        } else if (status === "TESLIM_EDILDI") {
            htmlResult = "TESLİM EDİLDİ"
        } else {
            htmlResult = "";
        }
        return (
            <span>
        <p style={{margin: 0}}
           className={status === "TESLIM_EDILDI" ? "text-success" : (status === "TESLIM_EDILMEDI" ? "text-danger" : "text-secondary")}>
				{htmlResult}
        </p>
        </span>
        );
    }

    copied(paymentLink) {
        if (paymentLink) {
            Alert.success("Ödeme Linki Kopyalandı", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    }

    renderResponseMessage(){
        let {responseType, responseMsg} = this.state;
        Swal.fire({
            title: responseType === "error" ? 'Hata!' : "Başarılı!",
            text: responseMsg,
            icon: responseType,
            confirmButtonText: 'Tamam',
            timer: 4000,
            timerProgressBar: true,
            onClose: () => {
                this.setState({ responseType: null, responseMsg: null });
            },
        });
    };



    render() {
        let {filteredDistricts, registerInfos, data, customer} = this.state;
        return (
            <div>{this.state.responseType && this.state.responseMsg && this.renderResponseMessage()}
            <DefaultModal
                disabled={this.state.loading}
                isOpen={this.props.modal}
                title="Mali Mühür Talep Oluştur"
                size="xl"
                cancelBtnText="Kapat"
                onCancel={this.props.onClose}>
                <ModalBody>
                    <div className=" row col-sm-12" style={{
                        marginLeft: '0px',
                        marginTop: '10px',
                        paddingTop: '15px',
                        border: "2px solid #e7e7e7",
                        borderRadius: "6px"
                    }}>
                        <div className="col-sm-6">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">Ad: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciAd")}>
                                        <input type="text"
                                               id="kullaniciAd"
                                               disabled={customer && customer.vknTckn && customer.vknTckn.length !== 10}
                                               className="form-control"
                                               data-vlength="2,50"
                                               data-vdata="string"
                                               onBlur={(e) => this.validateField(e, "Ad")}
                                               value={data.kullaniciAd}
                                               onChange={(e) => this.onValueChange(e, "kullaniciAd")}/>
                                        {this.validateMessage('kullaniciAd') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciAd" delay={0}>
                                                {this.validateMessage("kullaniciAd")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">TC Kimlik No: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciKimlikNo")}>
                                        <input type="text"
                                               id="kullaniciKimlikNo"
                                               data-vlength="11,11"
                                               data-vdata="identifier"
                                               onBlur={(e) => this.validateField(e, "kullaniciKimlikNo")}
                                               className="form-control"
                                               value={data.kullaniciKimlikNo}
                                               disabled={customer && customer.vknTckn && customer.vknTckn.length === 11}
                                               onChange={(e) => this.onValueChange(e, "kullaniciKimlikNo")}/>
                                        {this.validateMessage('kullaniciKimlikNo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciKimlikNo" delay={0}>
                                                {this.validateMessage("kullaniciKimlikNo")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">Soyad: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciSoyad")}>
                                        <input type="text"
                                               id="kullaniciSoyad"
                                               className="form-control"
                                               data-vlength="2,50"
                                               data-vdata="string"
                                               onBlur={(e) => this.validateField(e, "Soyad")}
                                               value={data.kullaniciSoyad}
                                               disabled={customer && customer.vknTckn && customer.vknTckn.length !== 10}
                                               onChange={(e) => this.onValueChange(e, "kullaniciSoyad")}/>
                                        {this.validateMessage('kullaniciSoyad') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciSoyad" delay={0}>
                                                {this.validateMessage("kullaniciSoyad")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">Vergi Dairesi: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("vergiDairesi")}>
                                        <input className="form-control"
                                               type="text"
                                               id="vergiDairesi"
                                               data-vlength="2,40"
                                               data-vdata="vergiDairesi"
                                               onBlur={(e) => this.validateField(e, "vergiDairesi")}
                                               value={data.vergiDairesi}
                                               onChange={(e) => this.onValueChange(e, "vergiDairesi")}/>
                                        {this.validateMessage('vergiDairesi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="vergiDairesi" delay={0}>
                                                {this.validateMessage("vergiDairesi")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">Doğum Tarihi: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciDogumTarihi")}>
                                        <Datetime locale="tr"
                                                  className="datepicker"
                                                  input={true}
                                                  inputProps={{
                                                      placeholder: "GG-AA-YYYY",
                                                      id: 'kullaniciDogumTarihi',
                                                      dataset: {
                                                          vdata: "date",
                                                          vlength: "1,255",
                                                          value: data.kullaniciDogumTarihi
                                                      }
                                                  }}
                                                  onBlur={(momentObj) => {
                                                      const formattedDate = (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj);
                                                      this.validateField({
                                                          target: {
                                                              id: "kullaniciDogumTarihi",
                                                              dataset: {'vdata': "date", 'vlength': "1,255"},
                                                              value: formattedDate
                                                          }
                                                      });
                                                  }}
                                                  closeOnSelect={false}
                                                  value={data.kullaniciDogumTarihi}
                                                  dateFormat="DD-MM-YYYY"
                                                  ref="kullaniciDogumTarihi"
                                                  isValidDate={function (current) {
                                                      return current.isBefore(Datetime.moment());
                                                  }}
                                                  timeFormat={false}
                                                  onChange={(momentObj) => {
                                                      const formattedDate = (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj);
                                                      this.onValueChange({
                                                          target: {
                                                              name: 'kullaniciDogumTarihi',
                                                              value: formattedDate
                                                          }
                                                      }, "kullaniciDogumTarihi");
                                                  }}
                                        />
                                        {this.validateMessage('kullaniciDogumTarihi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciDogumTarihi"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciDogumTarihi")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">Cep Telefonu: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciCepTelefonu")}>
                                        <input className="form-control"
                                               placeholder=""
                                               type="text"
                                               id="kullaniciCepTelefonu"
                                               data-vlength="10,10"
                                               data-vdata="telephone"
                                               onBlur={(e) => this.validateField(e, "kullaniciCepTelefonu")}
                                               value={data.kullaniciCepTelefonu}
                                               onChange={(e) => this.onValueChange(e, "kullaniciCepTelefonu")}/>
                                        {this.validateMessage('kullaniciCepTelefonu') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciCepTelefonu"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciCepTelefonu")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-sm-6">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">Doğum Yeri: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciDogumYeri")}>
                                        <input className="form-control"
                                               type="text"
                                               id="kullaniciDogumYeri"
                                               data-vlength="3,100"
                                               data-vdata="dogumYeri"
                                               onBlur={(e) => this.validateField(e, "kullaniciDogumYeri")}
                                               value={data.kullaniciDogumYeri}
                                               onChange={(e) => this.onValueChange(e, "kullaniciDogumYeri")}/>
                                        {this.validateMessage('kullaniciDogumYeri') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciDogumYeri"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciDogumYeri")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">İş Telefonu: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciIsTelefonu")}>
                                        <input className="form-control"
                                               id="kullaniciIsTelefonu"
                                               type="text"
                                               data-vlength="10,10"
                                               data-vdata="telephone"
                                               onBlur={(e) => this.validateField(e, "kullaniciIsTelefonu")}
                                               value={data.kullaniciIsTelefonu}
                                               onChange={(e) => this.onValueChange(e, "kullaniciIsTelefonu")}/>
                                        {this.validateMessage('kullaniciIsTelefonu') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciIsTelefonu"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciIsTelefonu")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-sm-6">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">İl: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciIl")}>
                                        <Select
                                            id="kullaniciIl"
                                            value={data.kullaniciIl !== null ?
                                                data.kullaniciIl : ''}
                                            clearable={false}
                                            noResultsText="Sonuç yok"
                                            clearValueText="Temizle"
                                            placeholder="Seçiniz..."
                                            maxLength="100"
                                            onBlur={() => this.validateField({
                                                target: {
                                                    id: "kullaniciIl",
                                                    dataset: {'vlength': "1,255"},
                                                    value: data.kullaniciIl
                                                }
                                            })}
                                            onChange={(e) => this.onValueChange({
                                                target: {
                                                    value: e.value,
                                                    label: e.label
                                                }
                                            }, "kullaniciIl")}
                                            options={this.state.cities && this.state.cities.map(city => ({
                                                value: city.cityCode,
                                                label: city.cityName
                                            }))}
                                        />
                                        {this.validateMessage('kullaniciIl') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciIl"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciIl")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">Adres: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciAdresi")}>
                                        <input className="form-control"
                                               id="kullaniciAdresi"
                                               type="text"
                                               data-vlength="20,255"
                                               data-vdata="adres"
                                               onBlur={(e) => this.validateField(e, "kullaniciAdresi")}
                                               value={data.kullaniciAdresi}
                                               onChange={(e) => this.onValueChange(e, "kullaniciAdresi")}/>
                                        {this.validateMessage('kullaniciAdresi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciAdresi" delay={0}>
                                                {this.validateMessage("kullaniciAdresi")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 ">
                            <div className="row">
                                <label className="col-sm-5 col-form-label">İlçe: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciIlce")}>
                                        <Select
                                            id="kullaniciIlce"
                                            value={data.kullaniciIlce !== null ?
                                                data.kullaniciIlce : ''}
                                            clearable={false}
                                            noResultsText="Sonuç yok"
                                            clearValueText="Temizle"
                                            placeholder="Seçiniz..."
                                            maxLength="100"
                                            onBlur={() => this.validateField({
                                                target: {
                                                    id: "kullaniciIlce",
                                                    dataset: {'vlength': "1,255"},
                                                    value: data.kullaniciIlce
                                                }
                                            })}
                                            onChange={(e) => this.onValueChange({
                                                target: {
                                                    value: e.value,
                                                    label: e.label
                                                }
                                            }, "kullaniciIlce")}
                                            options={filteredDistricts.map(district => ({
                                                value: district.districtCode,
                                                label: district.districtName
                                            }))}
                                        />
                                        {this.validateMessage('kullaniciIlce') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciIlce"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciIlce")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-5 col-form-label">E-Posta: *</label>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass("kullaniciIletisimEposta")}>
                                        <MaskedInput className="form-control"
                                                     type="text"
                                                     mask={emailMask}
                                                     name="kullaniciIletisimEposta"
                                                     inputProps={{vdata: "email", vlength: '2,255'}}
                                                     id="kullaniciIletisimEposta"
                                                     onBlur={() => this.validateField({
                                                         target: {
                                                             id: "kullaniciIletisimEposta",
                                                             dataset: {vdata: "email", vlength: '2,255'},
                                                             value: data.kullaniciIletisimEposta
                                                         }
                                                     })}
                                                     value={data.kullaniciIletisimEposta}
                                                     placeholder="_________@______.___"
                                                     ref="kullaniciIletisimEposta"
                                                     onChange={(e) => this.onValueChange(e, "kullaniciIletisimEposta")}/>
                                        {this.validateMessage('kullaniciIletisimEposta') !== "" &&
                                            <UncontrolledTooltip placement="right" target="kullaniciIletisimEposta"
                                                                 delay={0}>
                                                {this.validateMessage("kullaniciIletisimEposta")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {customer && customer.vknTckn && customer.vknTckn.length === 10 &&
                            <div className="col-sm-6 ">
                                {data.tuzel ?
                                    <div className="row">
                                        <label className="col-sm-5 col-form-label">Vergi Kimlik No: *</label>
                                        <div className="col-sm-7">
                                            <div className={"form-group" + this.validateClass("kullaniciVergiNo")}>
                                                <input className="form-control"
                                                       id="kullaniciVergiNo"
                                                       type="text"
                                                       disabled={customer && customer.vknTckn && customer.vknTckn.length === 10}
                                                       data-vdata="vergiKimlikNo"
                                                       value={data.kullaniciVergiNo}
                                                       onChange={(e) => this.onValueChange(e, "kullaniciVergiNo")}/>
                                                {this.validateMessage('kullaniciVergiNo') !== "" &&
                                                    <UncontrolledTooltip placement="right" target="kullaniciVergiNo"
                                                                         delay={0}>
                                                        {this.validateMessage("kullaniciVergiNo")}
                                                    </UncontrolledTooltip>}
                                            </div>
                                        </div>
                                    </div> :
                                    <></>
                                }
                            </div>
                        }

                        <div className="col-sm-12">
                            <Button className="TekBtn kaydet pull-right"
                                    disabled={((this.state.loading || this.state.registerInfos.length >= 2) && !this.state.editMode) || this.state.saveLoading}
                                    onClick={(e) => this.saveRequest(e)}>
                                {(this.state.loading ||  this.state.saveLoading)? (
                                        <ReactLoading type="spin" color="#2c2c2c" height={20} width={20}/>
                                    ) :
                                    "Kaydet"
                                }
                            </Button>
                            {this.state.registerInfos.length >= 2 && <h4 className="text-danger" style={{textAlign: 'center', marginTop:"5px"}}>Müşteri maksimum kayıt miktarına ulaştınız!</h4>}
                        </div>
                    </div>

                    <Row>
                        <div className="card-header">
                            <h4 className="card-title"></h4>
                        </div>
                        <Col xs="12">
                            <table className="" style={{textAlign: 'center'}}>
                                <thead>
                                <tr style={{backgroundColor: '#ebedf0'}}>
                                    <th>#</th>
                                    <th>Ad</th>
                                    <th>Soyad</th>
                                    <th>TC Kimlik No</th>
                                    {/*{this.state.shouldPayment &&
                                        <th>Ödenecek Tutar</th>
                                    }
                                    {this.state.shouldPayment &&
                                        <th>Ödeme Durumu</th>
                                    }*/}
                                    <th>Barkod</th>
                                    <th>Ödeme Durumu</th>
                                    <th>Teslimat Durumu</th>
                                    <th>Teslimat Tarihi</th>
                                    <th>İşlemler</th>
                                </tr>
                                </thead>
                                {registerInfos && registerInfos.length > 0 && registerInfos.map((registerInfo, index) =>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{registerInfo.kullaniciAd}</td>
                                        <td>{registerInfo.kullaniciSoyad}</td>
                                        <td>{registerInfo.kullaniciKimlikNo}</td>
                                        <td>{registerInfo.barcode}</td>
                                        <td>{this.getOdemeDurumu(registerInfo.odemeDurumu)}</td>
                                        <td>{this.getTeslimatDurumu(registerInfo.teslimatDurumu)}</td>
                                        <td>{registerInfo.teslimatTarihi}</td>
                                        <td>

                                            <div className="btn-group">

                                                <div className="dropdown">
                                                    <button className="MenuBtn2 listt " type="button"
                                                            data-toggle="dropdown">Seçİnİz
                                                    </button>
                                                    <div className="dropdown-menu" style={{margin: '0 0 75px 60px'}}
                                                         aria-labelledby={"dropdownMenuButton_" + index}>
                                                        {!this.state.loading && (registerInfo.barcode === null || registerInfo.barcode === "") &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.handleEdit(registerInfo)}>
                                                                <i className="fa fa-edit"/> Düzenle
                                                            </a>
                                                        }
                                                        {!this.state.loading && this.state.shouldPayment === 1 && registerInfo.status !== 2 &&
                                                            <>
                                                                <a className="dropdown-item"
                                                                   onClick={() => this.payment(registerInfo.merchantOid)}>
                                                                    <i className="fa fa-credit-card"/> Ödeme Yap
                                                                </a>
                                                                <CopyToClipboard
                                                                    text={this.props.paytrDomain + "/external/" + registerInfo.merchantOid}
                                                                    onCopy={() => this.copied(this.props.paytrDomain + "/external/" + registerInfo.merchantOid)}>
                                                                    <a className="dropdown-item">
                                                                        <i className="fa fa-clipboard"/> Ödeme Linkini
                                                                        Kopyala
                                                                    </a>
                                                                </CopyToClipboard>
                                                            </>
                                                        }
                                                        {!this.state.loading && (((this.state.shouldPayment === 1 && registerInfo.status === 2) || (this.state.shouldPayment !== 1)) && registerInfo.barcode === null) &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.sendRequest(registerInfo.recordId)}>
                                                                <i className="fa fa-send"/> Gönder
                                                            </a>
                                                        }

                                                        {(!this.state.loading && registerInfo.barcode !== null && (registerInfo.odemeDurumu === "ODENMEDI" || registerInfo.teslimatDurumu === "TESLIM_EDILMEDI")) &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.checkStatus(registerInfo.barcode)}>
                                                                <i className="fa fa-search"/> Durumu Sorgula
                                                            </a>
                                                        }

                                                        {(!this.state.loading && registerInfo.barcode !== null && (registerInfo.odemeDurumu === "ODENDI" && registerInfo.teslimatDurumu === "TESLIM_EDILMEDI")) &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.openReportDeliveryModal(registerInfo)}>
                                                                <i className="fa fa-paper-plane"/> Teslim Bildir
                                                            </a>
                                                        }

                                                        {(!this.state.loading && registerInfo.barcode !== null && (registerInfo.teslimatDurumu === "TESLIM_EDILDI")) &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.downloadDocument(registerInfo.recordId)}>
                                                                <i className="fa fa-file-pdf-o"/> Teslimat Tutanağı
                                                                İndir
                                                            </a>
                                                        }
                                                        {(!this.state.loading && registerInfo.barcode !== null && (registerInfo.teslimatDurumu === "TESLIM_EDILDI")) &&
                                                            <a className="dropdown-item"
                                                               onClick={() => this.setUploadFilesModal(registerInfo)}>
                                                                <i className="fa fa-paper-plane"/> Teslimat Tutanağı Yükle
                                                            </a>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </td>
                                    </tr>)}
                            </table>
                        </Col>
                    </Row>
                </ModalBody>
                <Modal isOpen={this.state.reportDeliveryModal} size="md">
                    <ModalHeader className="justify-content-center">
                        Teslim Edilen Bilgisi
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <FormGroup row>
                                <Label sm={6} for="teslimEdilenAdSoyad">Teslim Edilen Ad Soyad: *</Label>
                                <Col sm={6}>
                                    <div className={"form-group" + this.validateClass("teslimEdilenAdSoyad")}>
                                        <input className="form-control"
                                               id="teslimEdilenAdSoyad"
                                               type="text"
                                               name="teslimEdilenAdSoyad"
                                               autoComplete={"false"}
                                               data-vlength="2,50"
                                               data-vdata="string"
                                               onBlur={(e) => this.validateField(e, "teslimEdilenAdSoyad")}
                                               value={this.state.teslimEdilenAdSoyad}
                                               onChange={(e) => this.setState({teslimEdilenAdSoyad: e.target.value})}/>
                                        {this.validateMessage('teslimEdilenAdSoyad') !== "" &&
                                            <UncontrolledTooltip placement="right" target="teslimEdilenAdSoyad"
                                                                 delay={0}>
                                                {this.validateMessage("teslimEdilenAdSoyad")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={6} for="teslimEdilenTckn">Teslim Edilen TCKN: *</Label>
                                <Col sm={6}>
                                    <div className={"form-group" + this.validateClass("teslimEdilenTckn")}>
                                        <input className="form-control"
                                               id="teslimEdilenTckn"
                                               data-vlength="11,11"
                                               data-vdata="identifier"
                                               onBlur={(e) => this.validateField(e, "teslimEdilenTckn")}
                                               type="text"
                                               name="teslimEdilenTckn"
                                               autoComplete="false"
                                               value={this.state.teslimEdilenTckn}
                                               onChange={(e) => this.setState({teslimEdilenTckn: e.target.value})}/>
                                        {this.validateMessage('teslimEdilenTckn') !== "" &&
                                            <UncontrolledTooltip placement="right" target="teslimEdilenTckn"
                                                                 delay={0}>
                                                {this.validateMessage("teslimEdilenTckn")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={6} for="teslimEdilenTelefon">Teslim Edilen Telefon: *</Label>
                                <Col sm={6}>
                                    <div className={"form-group" + this.validateClass("teslimEdilenTelefon")}>
                                        <input className="form-control"
                                               id="teslimEdilenTelefon"
                                               type="text"
                                               data-vlength="10,10"
                                               data-vdata="telephone"
                                               onBlur={(e) => this.validateField(e, "teslimEdilenTelefon")}
                                               value={this.state.teslimEdilenTelefon}
                                               onChange={(e) => this.setState({teslimEdilenTelefon: e.target.value})}/>
                                        {this.validateMessage('teslimEdilenTelefon') !== "" &&
                                            <UncontrolledTooltip placement="right" target="teslimEdilenTelefon"
                                                                 delay={0}>
                                                {this.validateMessage("teslimEdilenTelefon")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </Col>
                            </FormGroup>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary"
                                onClick={() => this.setState({reportDeliveryModal: false, teslimEdilenAdSoyad: null, teslimEdilenTckn: null, basvuruNo: null, teslimEdilenTelefon:null })}>
                            Kapat
                        </Button>
                        <Button style={{paddingLeft: '16px', width: '100px'}} color="success"
                                onClick={() => this.reportDelivery()}>
                            Kaydet
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.uploadFilesModal} size="lg">
                    <ModalHeader className="justify-content-center">
                        Doküman Yükle
                    </ModalHeader>
                    <ModalBody>
                        {this.state.uploadFileType == null && this.state.selectedItem == null ?
                            <ReactLoading type="spinningBubbles" style={{
                                width: "160px",
                                height: "160px",
                                margin: "20px auto 5px auto",
                                fill: "#888"
                            }}/>
                            :

                            <div className=" row col-sm-12" style={{
                                margin: '10px 0 0 0',
                                paddingTop: '15px',
                                border: "2px solid #e7e7e7",
                                borderRadius: "6px"
                            }}>
                                {this.state.uploadFileType === "teslimTutanagi" &&
                                    <div className="col-sm-6">
                                        <div style={{marginLeft: "18px"}}>
                                            <input className="checkbox-design" type="checkbox"
                                                   value={this.state.selectedItem.teslimTutanagi}
                                                   style={{margin: "0 15px 8px 5px"}}
                                                   id="teslimTutanagiCheckbox" disabled
                                                   checked={this.state.selectedItem.teslimTutanagi}/>
                                            <Label class="" style={{fontSize: "17px", marginBottom: "-2px"}}>Teslim Tutanağı </Label> <label style={{fontSize: "12px", color: '#10a110'}}>{this.state.selectedItem.teslimTutanagi ? "(Belge başarıyla yüklendi)" : ""}</label>
                                            <label style={{color: '#ef2922',fontWeight: "bold", fontSize: '12px', paddingTop: "0px", marginTop: "-8px", marginBottom: "-5px"}} className="col-form-label">* Teslim tutanağının görselinde kimlik belgesininde görselinin olması gerekmektedir. </label>
                                            {this.state.loadingType !== null && this.state.loadingType === "TeslimTutanagi" ?
                                                <ReactLoading type="spinningBubbles" style={{
                                                    width: "160px",
                                                    height: "160px",
                                                    margin: "20px auto 5px auto",
                                                    fill: "#888"
                                                }}/>
                                                :
                                                <DraggerUpload style={{marginTop: "0px"}} disabled={false}
                                                               type={"TeslimTutanagi"}
                                                               uploadFiles={this.uploadFiles}/>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.isImzaSirkuleri &&
                                    <div className="col-sm-6">
                                        <div style={{marginLeft: "18px"}}>
                                            <input className="checkbox-design" type="checkbox"
                                                   value={this.state.selectedItem.imzaSirkuleri}
                                                   style={{margin: "0 15px 8px 5px"}}
                                                   id="imzaSirkuleriCheckbox" disabled
                                                   checked={this.state.selectedItem.imzaSirkuleri}/>
                                            <Label class="" style={{fontSize: "17px"}}>İmza Sirküleri</Label> <label style={{fontSize: "12px", color: '#10a110'}}>{this.state.selectedItem.imzaSirkuleri ? "(Belge başarıyla yüklendi)" : ""}</label>
                                            {this.state.loadingType !== null && this.state.loadingType === "ImzaSirkuleri" ?
                                                <ReactLoading type="spinningBubbles" style={{
                                                    width: "160px",
                                                    height: "160px",
                                                    margin: "20px auto 5px auto",
                                                    fill: "#888"
                                                }}/>
                                                :
                                                <DraggerUpload style={{marginTop: "36px"}} disabled={false}
                                                               type={"ImzaSirkuleri"}
                                                               uploadFiles={this.uploadFiles}/>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.uploadFileType === "vekalet" &&
                                    <>
                                        <div className="col-sm-6">
                                            <div style={{marginLeft: "0px"}}>
                                                <input className="checkbox-design" disabled type="checkbox"
                                                       checked={this.state.selectedItem.vekalet}
                                                       value={this.state.selectedItem.vekalet} id="vekaletCheckbox"
                                                       style={{margin: "0 15px 8px 5px"}}/>
                                                <Label style={{fontSize: "17px"}}>Vekalet</Label> <label style={{fontSize: "12px", color: '#10a110'}}>{this.state.selectedItem.vekalet ? "(Belge başarıyla yüklendi)" : ""}</label>
                                                {this.state.loadingType !== null && this.state.loadingType === "Vekalet" ?
                                                    <ReactLoading type="spinningBubbles" style={{
                                                        width: "160px",
                                                        height: "160px",
                                                        margin: "20px auto 5px auto",
                                                        fill: "#888"
                                                    }}/>
                                                    :
                                                    <DraggerUpload style={{marginTop: "36px"}} disabled={false}
                                                                   type={"Vekalet"}
                                                                   uploadFiles={this.uploadFiles}/>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div style={{marginLeft: "18px"}}>
                                                <input className="checkbox-design" disabled type="checkbox"
                                                       checked={this.state.selectedItem.vekaletBeyani}
                                                       value={this.state.selectedItem.vekaletBeyani}
                                                       id="vekaletBeyaniCheckbox"
                                                       style={{margin: "0 15px 8px 5px"}}/>
                                                <Label style={{fontSize: "17px"}}>Vekalet Beyanı</Label> <label style={{fontSize: "12px", color: '#10a110'}}>{this.state.selectedItem.vekaletBeyani ? "(Belge başarıyla yüklendi)" : ""}</label>
                                                {this.state.loadingType !== null && this.state.loadingType === "VekaletBeyani" ?
                                                    <ReactLoading type="spinningBubbles" style={{
                                                        width: "160px",
                                                        height: "160px",
                                                        margin: "20px auto 5px auto",
                                                        fill: "#888"
                                                    }}/>
                                                    :
                                                    <DraggerUpload style={{marginTop: "36px"}} disabled={false}
                                                                   type={"VekaletBeyani"}
                                                                   uploadFiles={this.uploadFiles}/>
                                                }
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary"
                                onClick={() => this.setState({uploadFilesModal: false, selectedItem: {}, uploadFileType: null, isImzaSirkuleri: false})}>
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>

            </DefaultModal>
            </div>

        )
    }
}

export default FinancialSealModal;